// extracted by mini-css-extract-plugin
export default {"root":"ViewReport_root__BcalN","refereeReport":"ViewReport_refereeReport__WNIJJ"};